import React       from 'react';
import { connect } from 'react-redux';
import classNames  from 'classnames';

import { GridCell }      from '../../atoms/Layout/GridCell/GridCell';
import { GridRow }       from '../../atoms/Layout/GridRow/GridRow';
import { Text }          from '../../atoms/Text/Text';
import { ScoreBoxModel } from '../../models/ScoreBoxModel';
import { User }          from '../../models/User';
import ScoreService      from '../../services/RemoteScoreService';
import { GameState }     from '../../models/Enums';
import styles            from './ScoreBox.css';

type UserTopScoresProps = {
    slug: string;
    user: User;
    gameState: GameState;
    scoreBox: ScoreBoxModel;
};

interface RootState {
    scoreBox: ScoreBoxModel,
    user: User
}

class ScoreBoxComponent extends React.Component<UserTopScoresProps> {

    render() {
        const { scoreBox, user } = this.props;

        if (!scoreBox || !user) {
            return null;
        }

        return (
            <Container data-element-description = "user top scores">
                <Columns>
                    <Column size = {2.8}>
                        <Section>
                            <Text className = {styles.userIcon}>
                                <img src = "/icons/star.png" alt = ""/>
                            </Text>
                            <UserName align = "center" size = "md" bold = {true}>
                                {user.name}
                            </UserName>
                        </Section>
                    </Column>

                    <Column size = {2.9}>
                        <Section>
                            <Text size = "h2" bold = {true}>
                                {ScoreService.formatScore(scoreBox.daily)}
                            </Text>
                            <Text align = "center">Daily Top Score</Text>
                        </Section>
                    </Column>

                    <Column size = {2.9}>
                        <Section>
                            <RedText size = "h2" bold = {true}>
                                {ScoreService.formatScore(scoreBox.userDaily)}
                            </RedText>
                            <Text align = "center">Your Daily Top Score</Text>
                        </Section>
                    </Column>

                    <Column size = {3.3}>
                        <Section>
                            <RedText size = "h2" bold = {true}>
                                {ScoreService.formatScore(scoreBox.userAllTime)}
                            </RedText>
                            <Text align = "center">Your All-Time Top Score</Text>
                        </Section>
                    </Column>
                </Columns>
            </Container>
        );
    }
}



export const ScoreBox = connect(
    (state : RootState, props) => ({
        scoreBox: state.scoreBox,
        user: state.user,
    }))(ScoreBoxComponent);

const Container = (props: any) => <div className = {styles.container} {...props} />;
const Columns = (props: any) => <GridRow className = {styles.columns} {...props} />;
const Column = (props: any) => <GridCell className = {styles.column} {...props} />;
const Section = (props: any) => <div className = {styles.section} {...props} />;
const RedText = (props: any) => <Text className = {styles.redText} {...props} />;
const UserName = (props: any) => <RedText className = {[styles.userName, styles.redText]} {...props} />;
